import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = "/api";
const authHeader = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
});

/**
 * PATCH otimista de hidden_from_avg. Atualiza o estado local via `applyLocal`
 * antes da chamada e reverte se falhar. No sucesso chama `refresh()` pra que
 * o backend recalcule avg_geral/distribuição (sem fazer matemática no cliente).
 *
 * Retorna { toggle(reviewId, currentHidden), pending: { [reviewId]: true } }.
 */
export function useToggleReviewHidden({ applyLocal, refresh }) {
  const [pending, setPending] = useState({});

  const toggle = async (reviewId, currentHidden) => {
    const next = !currentHidden;
    setPending((p) => ({ ...p, [reviewId]: true }));
    applyLocal(reviewId, next);
    try {
      await axios.patch(
        `${API}/reports/reviews/${reviewId}/hidden`,
        { hidden: next },
        authHeader(),
      );
      if (refresh) refresh();
    } catch (e) {
      // revert
      applyLocal(reviewId, currentHidden);
      toast.error(e.response?.data?.detail || "Erro ao alterar visibilidade");
    } finally {
      setPending((p) => {
        const copy = { ...p };
        delete copy[reviewId];
        return copy;
      });
    }
  };

  return { toggle, pending };
}
